module.exports = __webpack_public_path__ + "img/ORDER-CNN.a4b2d6c2.png";